import { useIsPriceEstimatorEnabled } from '@client/hooks/use-pricing';
import { EmptyStateSearchLink } from '@client/pages/Storefront/components/EmptyStateSearchLink/EmptyStateSearchLink';
import { CUSPricingDetails } from '@components/pricing/pricing-details/CUSPricingDetails';
import { PricingDetails } from '@components/pricing/pricing-details/PricingDetails';
import { useStorefrontCouplesUsuallySpend } from '@hooks/useStorefrontCouplesUsuallySpend';
import { useTrackStorefrontImpression } from '@hooks/useTrackStorefrontImpression';
import { H3 } from '@xo-union/tk-ui-typography';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import React, { type FC, memo } from 'react';
import {
	hasSeasonalPricingAtom,
	hidePricingAtom,
} from '../../jotai/storefront/pricing';
import type { NavItemProps } from '../../pages/Storefront/containers/nav/types';
import { SeasonalPricing } from './SeasonalPricing';
import { PricingFactors } from './SeasonalPricing/components/PricingFactors';
import Styles from './styles.scss';

export const VenuePricing: FC<NavItemProps> = memo(() => {
	const impressionRef = useTrackStorefrontImpression(
		'Venue Pricing Section & FAQs',
	);
	const shouldShowCUS = useStorefrontCouplesUsuallySpend();
	const isPriceEstimatorEnabled = useIsPriceEstimatorEnabled();

	const hidePricing = useAtomValue(hidePricingAtom);
	const hasSeasonalPricing = useAtomValue(hasSeasonalPricingAtom);

	if (hidePricing) return null;

	return (
		<div
			className={classNames([Styles.venuePricingRow])}
			data-seasonal-pricing={hasSeasonalPricing}
		>
			<H3 ref={impressionRef}>Pricing details</H3>
			{isPriceEstimatorEnabled ? (
				<>
					{hasSeasonalPricing ? (
						<>
							<SeasonalPricing />
							<PricingFactors />
						</>
					) : (
						<EmptyStateSearchLink
							header="No pricing details yet"
							text="We’re here to help! Find other vendors that suit your budget."
							linkText="Continue browsing vendors"
							storefrontSection="Venue Pricing FAQs"
							inline={false}
						/>
					)}
				</>
			) : shouldShowCUS ? (
				<CUSPricingDetails />
			) : (
				<PricingDetails />
			)}
		</div>
	);
});
